module.exports = {"140524100":"崇文镇","140524101":"礼义镇","140524102":"附城镇","140524103":"西河底镇","140524104":"平城镇","140524105":"杨村镇","140524106":"潞城镇","140524204":"夺火乡","140524206":"马圪当乡","140524207":"古郊乡","140524209":"六泉乡","140524212":"秦家庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140524.json
// module id = 311
// module chunks = 0